export default __webpack_public_path__ + "static/media/youngwoman.e00e92d1.svg";